import { render, staticRenderFns } from "./VaccinationTypePanel.vue?vue&type=template&id=ceb3463e&scoped=true&"
import script from "./VaccinationTypePanel.vue?vue&type=script&lang=js&"
export * from "./VaccinationTypePanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationTypePanel.vue?vue&type=style&index=0&id=ceb3463e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb3463e",
  null
  
)

export default component.exports